export default __webpack_public_path__ + "6be9a23ec79ef0ff636f5c600afc31d7.png";